import React from 'react';
import pt from 'prop-types';

import FeatureGate from 'app/launch-darkly/gates/feature-gate';
import { FEATURE_FLAGS } from 'app/launch-darkly/featureFlags';

import { useConsentCategoriesContext } from 'app/context/consent-categories-context';
import { ConsentCategoryDisabledMessage } from 'app/components/consent-categories-select/ConsentCategoryDisabledMessage';

const ConsentCategoryRow = ({ consentCategoryId }) => {
  const { consentCategories, loading } = useConsentCategoriesContext();
  if (loading) {
    return null;
  }
  const categoryData = consentCategories.find(category => category.id === consentCategoryId);

  return (
    <FeatureGate flagName={FEATURE_FLAGS.configurableConsentMvp}>
      <tr>
        <td>Consent Type</td>
        <td>
          <FeatureGate flagName={FEATURE_FLAGS.ecmConfigurableConsent} fallback={<ConsentCategoryDisabledMessage />}>
            <>{categoryData?.displayName}</>
          </FeatureGate>
        </td>
      </tr>
    </FeatureGate>
  );
};

ConsentCategoryRow.propTypes = {
  consentCategoryId: pt.string,
};
export default ConsentCategoryRow;
